import React from "react";
import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, onChange }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          type="button"
          key={n}
          disabled={!onChange}
          onClick={() => onChange && onChange(n)}
          data-testid={onChange ? `star-${n}` : undefined}
          className={onChange ? "transition-transform hover:scale-110" : "cursor-default"}
        >
          <Star size={size} className={n <= Math.round(value) ? "fill-[#FFB800] text-[#FFB800]" : "text-gray-300"} />
        </button>
      ))}
    </div>
  );
}
